import { Component, OnInit } from '@angular/core';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { PrivilegeService } from '@services/privileges/privilege.service';
import { DataTableEvent } from '../../components/data-table/data-table.component';

@Component({
    selector: 'app-privileges',
    templateUrl: './privileges.component.html',
    styleUrls: ['./privileges.component.scss'],
    providers: [PrivilegeService],
    standalone: false
})
export class PrivilegesComponent implements OnInit {

  public title = 'Privileges';

  public pageActions: PageAction[];

  public columns = [
    { prop: 'name' }
  ];

  constructor(public privilegeService: PrivilegeService, private router: Router) {
  }

  ngOnInit() {
    this.pageActions = [
      new PageAction({
        icon: 'add',
        title: 'Create Privilege',
        callback: () => {
          this.router.navigate(['privileges/create']);
        }
      })
    ];
  }

  public onDetail(event: DataTableEvent) {
    this.router.navigate(['privileges', event.row.PrivilegeID, 'edit']);
  }

}
